export const getAttributes = (accessibilityLabel, testID, accessibilityRole='none', accessible=false) => ({
    accessible,
    accessibilityLabel,
    testID,
    accessibilityRole
});
